import React, { useContext } from "react";
import { IntlContext } from "context";
import { useReferences } from "hooks/reference";
import { getListingDetailLabelKeys, type ListingCategoryDetail, type ListingDetailKind } from "./types";

interface Props {
    detail: ListingCategoryDetail;
    kind: ListingDetailKind;
}

const Tutoring: React.FC<Props> = ({ detail, kind }) => {
    const intl = useContext(IntlContext);
    const reference = useReferences();
    const { data } = detail;
    const labels = getListingDetailLabelKeys(kind);

    if (!data.academic_level?.length) {
        return null;
    }

    return (
        <>
            <label>{intl.formatMessage(labels.academicLevel)}</label>
            {data.academic_level.map((academicLevel, key) => {
                const academicLevelLength = data.academic_level?.length ?? 0;
                const translatedAcademicLevel = reference.get("scholar_level", academicLevel)?.value;

                if (key + 1 < academicLevelLength) {
                    return `${translatedAcademicLevel}, `;
                }

                return `${translatedAcademicLevel}`;
            })}
        </>
    );
};

export default Tutoring;
